import { cn as e } from "../shared/utils.js";
import { radioIndicatorVariants as t, radioRootVariants as n } from "./primitive/index.js";
import { jsx as r } from "react/jsx-runtime";
//#region src/radio/static-radio-button.tsx
var i = ({ checked: i, className: a }) => /* @__PURE__ */ r("div", {
	"aria-hidden": !0,
	className: e(n({ checked: i }), a),
	children: i ? /* @__PURE__ */ r("div", { className: t() }) : null
});
//#endregion
export { i as StaticRadioButton };
